import React, { useMemo, useState } from 'react';
import Chart from 'react-apexcharts';
import { Box, Typography, Card, Grid, Chip, CircularProgress } from '@mui/material';
import NoDataFound from '../../components/NodataIndication/NoDataFound';
import ToolTip from '../../components/ToolTip/ToolTip';

const DashboardChart = ({ data, keys = { label: 'label', value: 'value' }, totalCount, loading }) => {
  const labels = data.map((item) => item?.[keys?.label]);
  const dataValues = data.map((item) => Number(item?.[keys?.value]));

  const colors = [
    '#008FFB', // Blue
    '#00E396', // Green
    '#FEB019', // Orange
    '#FF4560', // Red
    '#775DD0', // Purple
    '#26A69A', // Teal
    '#546E7A', // Blue Grey
    '#D4526E', // Pink
    '#8D5B4C', // Brown
    '#F86624', // Deep Orange
  ];

  const chartData = useMemo(() => {
    return {
      series: dataValues,
      options: {
        chart: {
          type: 'donut',
        },
        labels: labels,
        colors: colors,
        legend: {
          show: false,
        },
        stroke: {
          width: 1,
        },
        plotOptions: {
          pie: {
            donut: {
              size: '65%',
              labels: {
                show: true,
                total: {
                  show: true,
                  label: 'Total Refunds',
                  fontSize: '20px',
                  fontWeight: '600',
                  color: '#333',
                  formatter: () => `${totalCount}`,
                },
              },
            },
          },
        },
        responsive: [
          {
            breakpoint: 768,
            options: {
              chart: { width: '100%' },
            },
          },
        ],
      },
    };
  }, [data]);

  return (
    <Card sx={{ p: 3, borderRadius: '16px', border: '1px solid #d698cfff', height: '100%' }}>
      <Typography variant="h6" fontWeight={600} mb={2} textAlign={'center'}>
        Refund Reasons Breakdown
      </Typography>

      {loading ? (
        <Box display={'flex'} alignItems={'center'} justifyContent={'center'} height={'100%'}>
          <CircularProgress />
        </Box>
      ) : data.length == 0 ? (
        <Box display={'flex'} alignItems={'center'} justifyContent={'center'} height={'70%'}>
          <NoDataFound />
        </Box>
      ) : (
        <>
          <Box>
            <Chart options={chartData.options} series={chartData.series} type="donut" height={'330px'} />
          </Box>

          <Grid container spacing={1} mt={2}>
            {labels.map((item, index) => (
              <Grid item xs={6} sm={4} key={index}>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    p: 1,
                    borderRadius: '12px',
                    backgroundColor: '#f9f9f9',
                    gap: 1,
                  }}
                >
                  <Box
                    sx={{
                      width: 14,
                      height: 14,
                      borderRadius: '50%',
                      backgroundColor: colors[index],
                    }}
                  />

                  <ToolTip
                    expand={item}
                    content={
                      <Typography
                        sx={{
                          fontWeight: 500,
                          fontSize: 14,
                          maxWidth: 80, // adjust width as needed
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                        }}
                      >
                        {item}
                      </Typography>
                    }
                  />

                  <Chip label={dataValues[index]} size="small" />
                </Box>
              </Grid>
            ))}
          </Grid>
        </>
      )}
    </Card>
  );
};

export default DashboardChart;
